import React from 'react';

import CalendarIcon from 'icons/calendar.svg';
import DesktopMobileIcon from 'icons/desktop-mobile.svg';
import { useTranslation } from 'react-i18next';

import ActionsPill from 'components/application/ActionsPill';

import { useCurrentActor } from 'components/contexts/CurrentActor';

import { formatDate } from 'components/helpers/dates';
import { resourceShape } from 'components/helpers/serialisableResources';

export default function TrainingRowBookingPill({
  booking,
  course,
  registration,
}) {
  const currentActor = useCurrentActor();

  const { t: i18nTCommon } = useTranslation('common');

  const courseHasELearningCourse =
    currentActor.isAllowedFeature('e_learning') &&
    !!course.relationships.eLearningCourse.data;

  return courseHasELearningCourse ?
      <ActionsPill
        color='cyan'
        displayText={
          registration ?
            i18nTCommon('courses.continueELearning')
          : i18nTCommon('courses.startELearning')
        }
        icon={<DesktopMobileIcon height={16} width={16} />}
      />
    : <ActionsPill
        color='cyan'
        displayText={i18nTCommon('bookings.bookedFor', {
          date: formatDate({
            date: booking.attributes.date,
            format: 'd MMM yy',
          }),
        })}
        icon={<CalendarIcon height={16} width={16} />}
      />;
}

TrainingRowBookingPill.propTypes = {
  course: resourceShape('course').isRequired,
  booking: resourceShape('booking').isRequired,
  registration: resourceShape('registration'),
};
